<div>
    <div class="loading-spinner" *ngIf="show">
        <div class="progress-panel">
            <mat-spinner *ngIf="mode === 'indeterminate'"></mat-spinner>
    
            <mat-progress-spinner
                *ngIf="mode === 'determinate'" 
                [mode]="'determinate'" 
                [value]="progress"
               >
            </mat-progress-spinner>
    
            <div class="action" *ngIf="action">{{ action }}</div>
        </div>
    </div>
</div>